import * as $ from 'jquery';
import Cookies from 'js-cookie';
import { AppModule } from '../../lib/app-module';
import { decodeBase64 } from '../../lib/base64';

const userDataCookieName = 'dc.user-data';

export interface UserNavOptions {
    userDropdownSelector: string;
    openUserSelector: string;
    userOpenToggleClass: string;
}

export interface UserModuleExport {
    render: (selector: string) => void;
    nav: (options: UserNavOptions) => void;
    signIn: () => void;
    signOut: () => void;
    fillEmail: (element: HTMLInputElement) => void;
    fillName: (element: HTMLInputElement) =>  void;
}

interface User {
    email: string;
    name: string;
    groups: string[];
}

const findAndSelf = (element: JQuery<HTMLElement>, selector: string): JQuery<HTMLElement> =>
    element.find(selector).add(element).filter(selector);

export class UserModule extends AppModule<undefined, UserModuleExport> {
    private user: User | undefined;
    protected init(): void {
        this.parseDataUserCookie();
        this._export = {
            render: (selector: string): void => { this.render(selector); },
            nav: (options: UserNavOptions): void =>  { UserModule.monitorOpenUser(options); },
            signIn: (): void => { this.signIn(); },
            signOut: (): void => { this.signOut(); },
            fillEmail: (inputElement: HTMLInputElement): void => {this.fillEmail(inputElement);},
            fillName: (inputElement: HTMLInputElement): void => {this.fillName(inputElement);}
        };
    }

    private parseDataUserCookie(): void {
        const cookieValue = Cookies.get(userDataCookieName);
        if (!cookieValue) { return ;}
        try {
            const decoded = decodeBase64(cookieValue);
            this.user = JSON.parse(decoded);
        } catch(error) {
            console.log('Can\'t parse user data: ', error);
        }
    }

    private static monitorOpenUser(options: UserNavOptions): void {
        const openUserElement = $(options.openUserSelector);
        const userDropdownElement = $(options.userDropdownSelector);

        openUserElement.on('click', (event) => {
            event.preventDefault();
            userDropdownElement.toggleClass(options.userOpenToggleClass);
        });
        userDropdownElement.on('focusout', (event) => {
            const currentTarget = event.currentTarget;
            requestAnimationFrame(() => {
                if (!currentTarget.contains(document.activeElement)) {
                    userDropdownElement.removeClass(options.userOpenToggleClass);
                }
            });
        });
    }

    private render(selector: string): void {
        const element = $(selector);
        if (this.user) {
            findAndSelf(element, '.u__name').text(this.user.name);
            findAndSelf(element, '.u__signedin').show();
            findAndSelf(element, '.u__signedout').hide();
            findAndSelf(element, '.u__material').each((_, child) => {
                const jqElement = $(child);
                const materialId = jqElement.data('material-id');
                this.user?.groups.includes(materialId) ? jqElement.show() : jqElement.hide();
            });
        } else {
            findAndSelf(element, '.u__signedin').hide();
            findAndSelf(element, '.u__signedout').show();
        }
    }

    private signOut(): void {
        Cookies.remove(userDataCookieName);
        this.user = undefined;
        window.location.href = '/auth/sign-out';
    }

    private signIn(): void {
        window.location.href = `/material/home/?${Date.now()}`;
    }

    private fillEmail(inputElement: HTMLInputElement): void {
        if (this.user) {
            $(inputElement).val(this.user?.email);
        }
    }

    private fillName(inputElement: HTMLInputElement): void {
        if (this.user) {
            $(inputElement).val(this.user?.name);
        }
    }
}